import type { I18nTranslation } from '@crehana/i18n';

import type { CREHANA_LEGAL_PAGE_KEY } from '@/views/CrehanaLegal/constants';

import en from './localeEn';
import es from './localeEs';
import pt from './localePt';

export type TKeys = keyof (typeof es)[typeof CREHANA_LEGAL_PAGE_KEY];

const locales: I18nTranslation = { en, es, pt };

export default locales;
